import Vue from 'vue'
import { Raven } from 'vue-raven'
import { API_REQUEST_STATUS } from '../const/endpoints.const'

const sdkFilesDir = '/autopay_sdk_mobile/v'
const storageKey = 'filesStorage'
const storageValidityTime = 1000 * 60 * 60 * 24
const OPTIONS = {
  credentials: true
}

export class ApiClass {
  getSdkFile (version, type, device, lang, ext) {
    return new Promise((resolve, reject) => {
      const url = sdkFilesDir + version + '/' + type + device + '-' + lang + ext
      let storageObj = ApiClass.getSessionStorageObject()
      if (storageObj.validUntil && storageObj.validUntil < new Date().getTime()) {
        sessionStorage.removeItem(storageKey)
      }
      if (storageObj[url]) {
        resolve(storageObj[url])
        return
      }
      apiClass.get(url)
        .then(
          response => {
            const data = response.body
            const storageObj = ApiClass.getSessionStorageObject()
            storageObj[url] = data
            storageObj.validUntil = new Date().getTime() + storageValidityTime
            sessionStorage.setItem(storageKey, JSON.stringify(storageObj))
            resolve(data)
          },
          error => reject(error)
        )
    })
  }

  get (endpoint, options = {}) {
    Object.assign(options, OPTIONS)

    let url = ApiClass.getBackendUrl(endpoint)

    return Vue.http.get(url, options).then(
      response => {
        if (response.body && response.body.status && response.body.status !== API_REQUEST_STATUS.success) {
          return Promise.reject(response.body.description)
        }
        return Promise.resolve(response)
      },
      error => {
        Raven.captureMessage('ApiClass GET Method response error', {
          extra: error
        })
        return Promise.reject(error)
      })
  }

  post (endpoint, data = {}, options = {}) {
    Object.assign(options, OPTIONS)
    let url = ApiClass.getBackendUrl(endpoint)

    return Vue.http.post(url, data, options).then(
      response => {
        if (response && response.body && typeof response.body !== 'object') {
          return Promise.reject(response)
        }
        if (response.body.status && response.body.status !== API_REQUEST_STATUS.success) {
          return Promise.reject(response.body.description)
        }

        return Promise.resolve(response)
      },
      error => {
        Raven.captureMessage('ApiClass POST Method response error', {
          extra: error
        })
        return Promise.reject(error)
      })
  }

  put (endpoint, data = {}, options = {}) {
    Object.assign(options, OPTIONS)
    let url = ApiClass.getBackendUrl(endpoint)

    return Vue.http.put(url, data, options).then(
      response => {
        if (response && response.body && typeof response.body !== 'object') {
          return Promise.reject(response)
        }
        if (response.body.status && response.body.status !== API_REQUEST_STATUS.success) {
          return Promise.reject(response.body.description)
        }

        return Promise.resolve(response)
      },
      error => {
        Raven.captureMessage('ApiClass PUT Method response error', {
          extra: error
        })
        return Promise.reject(error)
      })
  }

  delete (endpoint, data = {}, options = {}) {
    Object.assign(options, OPTIONS)
    let url = ApiClass.getBackendUrl(endpoint)

    return Vue.http.delete(url, data, options).then(
      response => {
        if (response && response.body && typeof response.body !== 'object') {
          return Promise.reject(response)
        }
        if (response.body.status && response.body.status !== API_REQUEST_STATUS.success) {
          return Promise.reject(response.body.description)
        }

        return Promise.resolve(response)
      },
      error => {
        Raven.captureMessage('ApiClass PUT Method response error', {
          extra: error
        })
        return Promise.reject(error)
      })
  }

  static getBackendUrl (endpoint) {
    return process.env.VUE_APP_API + endpoint
  }

  static getSessionStorageObject () {
    const storageVal = sessionStorage.getItem(storageKey)
    return storageVal ? JSON.parse(storageVal) : {}
  }
}

export let apiClass = new ApiClass()
